import React from "react";

export default function CardMobile({ gold, silver, bronze, total }) {
    return (
        <div className="medallero-body-MedallasTotal" >
            <div className="medallero-body-medallas">
                {String(gold).length !== 0 ? (
                    <div className="medalla-circulo">
                        <span className="oro">{gold}</span>
                    </div>
                ) : (
                    <div className="medalla-circulo">
                        <span className="medallero-body-medallas-vacia">
                            -
                        </span>
                    </div>
                )}
                {String(silver).length !== 0 ? (
                    <div className="medalla-circulo">
                        <span className="silver">{silver}</span>
                    </div>
                ) : (
                    <div className="medalla-circulo">
                        <span className="medallero-body-medallas-vacia">
                            -
                        </span>
                    </div>
                )}
                {String(bronze).length !== 0 ? (
                    <div className="medalla-circulo">
                        <span className="bronce">{bronze}</span>
                    </div>
                ) : (
                    <div className="medalla-circulo">
                        <span className="medallero-body-medallas-vacia">
                            -
                        </span>
                    </div>
                )}
                <div className="medallero-body-total">
                    <p className="">{total}</p>
                </div>
            </div>
        </div >
    )
}